import { useEffect, useState } from 'react';

import { TIME_FORMAT } from '@/lib/constants';
import { formatToLocationDateTime } from '@/utils/format';

interface Props {
  timezone: string;
}

const LocalClock = ({ timezone }: Props) => {
  const [currTime, setCurrTime] = useState<string>('');

  useEffect(() => {
    const tickClock = setInterval(() => {
      setCurrTime(formatToLocationDateTime(new Date(), timezone, TIME_FORMAT));
    }, 60);

    return () => clearInterval(tickClock);
  }, [timezone]);

  return <time dateTime={currTime}>{currTime}</time>;
};

export { LocalClock };
